// extracted by mini-css-extract-plugin
export default {"wrap":"BaseEditor_wrap__+aFMc","editorWrap":"BaseEditor_editorWrap__VHP5X","toolbar":"BaseEditor_toolbar__aNVO7","error":"BaseEditor_error__x6NfT"};